import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "sf-std-content"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-2xl tw-text-danger tw-font-bold" }, "Invalid User", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "You are logged in as a user for whom this link is not valid.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Please logout and try the link again.", -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "tw-text-2xl tw-text-danger tw-font-bold" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "tw-text-center tw-py-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegisterIndividual = _resolveComponent("RegisterIndividual")!
  const _component_RegisterSchool = _resolveComponent("RegisterSchool")!
  const _component_AccountTypeSelect = _resolveComponent("AccountTypeSelect")!
  const _component_MfJoinError = _resolveComponent("MfJoinError")!
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!
  const _component_ContactLink = _resolveComponent("ContactLink")!

  return (_ctx.isReady)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.canRegister)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.type == 'individual')
                ? (_openBlock(), _createBlock(_component_RegisterIndividual, {
                    key: 0,
                    "mf-token-data": _ctx.mfTokenData
                  }, null, 8, ["mf-token-data"]))
                : (_ctx.type == 'school')
                  ? (_openBlock(), _createBlock(_component_RegisterSchool, {
                      key: 1,
                      "mf-token-data": _ctx.mfTokenData
                    }, null, 8, ["mf-token-data"]))
                  : (_openBlock(), _createBlock(_component_AccountTypeSelect, { key: 2 }))
            ]))
          : (_ctx.mfToken)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.mfTokenData?.error == 'mfUserMoved')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_MfJoinError, {
                        error: _ctx.mfTokenData?.error
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" It is not possible to complete this action. ")
                        ]),
                        _: 1
                      }, 8, ["error"])
                    ]))
                  : (_ctx.mfTokenData?.error == 'invalidUser')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          (_ctx.mfTokenData?.error == 'expiredMfToken')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("Expired")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("Invalid")
                              ], 64)),
                          _createTextVNode(" Link ")
                        ]),
                        _createElementVNode("p", null, [
                          _createTextVNode(" To generate a new link "),
                          (_ctx.$currentUser.value)
                            ? (_openBlock(), _createBlock(_component_SfRouterLink, {
                                key: 0,
                                to: "/mf/join-sf"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("click here")
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, "please login with your Mathsframe credentials and follow the instructions in your dashboard")),
                          _createTextVNode(". ")
                        ]),
                        _createElementVNode("p", null, [
                          _createTextVNode("Or "),
                          _createVNode(_component_ContactLink),
                          _createTextVNode(" for further assistance.")
                        ])
                      ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, " You are already logged in. If you want to create a new account please logout first. "))
      ]))
    : _createCommentVNode("", true)
}